// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tDSBs66z4BZdh7ym29iqM"};